export default __webpack_public_path__ + "1ccd15d8251ef26569af9358e81827d2.png";